import React from 'react';
import {Col, Row} from 'react-bootstrap';

const DetailField = ({label, children}) => (
  <Row>
    <Col lg={3} sm={6}>
      {label}
      :
    </Col>
    <Col lg={3} sm={6}>
      {children}
    </Col>
  </Row>
);

export default DetailField;



// WEBPACK FOOTER //
// ./src/components/admin/ppc/user/detail-field.jsx